import React from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';

interface FormRetryCheckboxProps {
  userEmail: string | undefined;
  retry: boolean;
  onRetryChange: (retry: boolean) => void;
  disabled?: boolean;
}

const ALLOWED_EMAILS = ['lukasz.pindel@consultant.volvo.com', 'karol.szustalewicz@volvo.com'];

export const FormRetryCheckbox: React.FC<FormRetryCheckboxProps> = ({ userEmail, retry, onRetryChange, disabled }) => {
  if (disabled || !userEmail || !ALLOWED_EMAILS.includes(userEmail)) {
    return null;
  }

  return (
    <div className="retryCheckbox">
      <Checkbox label="Enable Retry" value={retry} onChange={e => onRetryChange(e.value ?? false)} />
    </div>
  );
};
